import React, { Fragment, useEffect, useState } from "react";
import { Flex, Form } from "antd";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { InputOTP } from "antd-input-otp";
import ButtonComponent from "@/components/button/Button";
import ModalComponent from "@/components/modal";

import {
  getToken,
  getUserMobileNumber,
  setCurrentForm,
  setModalOpen,
  setToken,
} from "@/reducers/commonSlice";

import { requestOtp } from "@/services/accounts/requestOtp";
import { verifyOtp } from "@/services/accounts/verifyOtp";

import "@/styles/pages/auth/verify-otp.scss";

const VerifyOTP = ({ isOpen = false }) => {
  const [secondsLeft, setSecondsLeft] = useState(60);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const dispatch = useDispatch();
  const userMobileNumber = useSelector(getUserMobileNumber);
  const token = useSelector(getToken);
  const [form] = Form.useForm();

  useEffect(() => {
    let interval = null;

    if (secondsLeft > 0) {
      interval = setInterval(() => {
        if (isOpen) {
          setSecondsLeft(secondsLeft - 1);
        }
      }, 1000);
    } else {
      setButtonDisabled(false);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [secondsLeft, isOpen]);

  const resendOTP = () => {
    requestOtp({
      mobileNumber: userMobileNumber,
    })
      .then((response) => {
        console.log(response.data);
        if (response.data.status === 400) {
          console.log("first");
          return form.setFields([
            {
              name: "otp",
              errors: [response.data?.message],
            },
          ]);
        } else {
          dispatch(setToken(response.data.token));
          setSecondsLeft(60);
          setButtonDisabled(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleFinish = (values) => {
    // The value will be array of string
    // Check the field if there is no value, or value is undefined/empty string
    const { otp } = values;
    if (!otp || otp.includes(undefined) || !otp?.length || otp?.length < 5)
      return form.setFields([
        {
          name: "otp",
          errors: ["Enter Valid OTP."],
        },
      ]);
    else {
      verifyOtp({
        otp: otp.join(""),
        token: token,
      })
        .then((response) => {
          dispatch(setCurrentForm("createAccount"));
        })
        .catch((error) => {
          return form.setFields([
            {
              name: "otp",
              errors: [error?.response?.data?.msg],
            },
          ]);
        });
    }
  };

  return (
    <Fragment>
      <ModalComponent
        buttonLabel="Verify OTP"
        isOpen={isOpen}
        className="onboarding-modal"
        maskClosable={false}
      >
        <div className="verify-otp-modal">
          <div className="header">Enter the 6-digit OTP sent on WhatsApp.</div>
          <div className="otp-countdown">
            <svg width="130" height="130" viewBox="0 0 120 120">
              <circle
                cx="60"
                cy="60"
                r="50"
                fill="none"
                stroke="#0000000a"
                strokeWidth="1"
                strokeLinecap="round"
              />
              <circle
                cx="60"
                cy="60"
                r="54"
                fill="none"
                stroke="#03A703"
                strokeWidth="8"
                strokeDasharray="339.292"
                strokeDashoffset={339.292 * (1 - secondsLeft / 60)}
                transform="rotate(-90 60 60)"
                strokeLinecap="round"
              />
              <text x="60" y="65" fontSize="20" fill="black" textAnchor="middle">
                0:{secondsLeft < 10 ? `0${secondsLeft}` : secondsLeft} sec
              </text>
            </svg>
          </div>
          <div className="form">
            <Form
              name="verifyOtp"
              layout="vertical"
              form={form}
              initialValues={{ remember: true }}
              onFinish={handleFinish}
            >
              <Form.Item
                name="otp"
                className="center-error-message"
                rules={[
                  {
                    required: true,
                    message: "Please enter valid OTP",
                    // pattern: new RegExp(/^([0-9]{6})$/),
                  },
                ]}
              >
                <InputOTP
                  autoFocus
                  inputType="numeric"
                  inputMode="numeric"
                  length={6}
                  pattern="\d*"
                  // onKeyPress={(event) => {
                  //   if (!/[0-9]/.test(event.key)) {
                  //     event.preventDefault();
                  //   }
                  // }}
                  // onPaste={(event) => {
                  //   const pastedData = event.clipboardData.getData("Text");
                  //   if (!/^\d+$/.test(pastedData)) {
                  //     event.preventDefault();
                  //   }
                  // }}
                />
              </Form.Item>
              <Form.Item>
                <div className="button">
                  <ButtonComponent
                    label="Verify OTP"
                    varient="primary"
                    htmlType="submit"
                  ></ButtonComponent>
                </div>
              </Form.Item>
            </Form>
            <Flex gap={"10px"} justify="center">
              <div className="resend-otp">
                <span onClick={resendOTP} className={classNames({ disabled: buttonDisabled })}>
                  Resend OTP
                </span>
              </div>
              <div className="resend-otp">
                <span onClick={() => dispatch(setModalOpen(false))}>Cancel</span>
              </div>
            </Flex>
          </div>
        </div>
      </ModalComponent>
    </Fragment>
  );
};

export default VerifyOTP;
